import {useRef, useEffect, useState} from 'react';
import cx from 'classnames';

import {gsap} from 'gsap';

import MathUtils from 'utils/MathUtils';

import styles from './SkewGallery.module.scss';

export default function SkewGalleryItem({
	children, progress, winsize, contHeight, debug, ready, zIndex, dupe
}){
	const wrap = useRef(null);
	const [pos, setPos] = useState({height: 0, top: 0, offset: 0});
	// const [img, setImg] = useState(null);
	const [ry, setRy] = useState(0);
	const [rz, setRz] = useState(0);
	const [rotation, setRotation] = useState(0);
	const [rotVal, setRotVal] = useState(0);
	// const [yOffset, setYOffset] = useState(0);
	const [normVal, setNormVal] = useState(-1);

	const getSize = () => {
		// const contPos = (contHeight - winsize.height) * progress;
		const rect = wrap.current.getBoundingClientRect();
		// debug && console.log(wrap.current.offsetTop);
		setPos({height: rect.height, top: rect.top, offset: wrap.current.offsetParent.offsetTop});
	}

	const update = () => {

		const offsetHeight = (progress * contHeight) - (progress * winsize.height);

		const padding = -0.0;

		const rotToValue = rotVal;
    const normalisedVal = MathUtils.map(
			offsetHeight + winsize.height, 
			(contHeight - (pos.offset + pos.height)) + (padding * 2 * winsize.height), 
			((contHeight - (pos.offset)) + winsize.height) - (padding * winsize.height),
			1,
			-1
		);
    const cappedVal = Math.min(
			Math.max(
				normalisedVal,
				-1
			),
			1
		);

		// debug && console.log(
		// );

		setNormVal(cappedVal);
		const newRotation = cappedVal * rotToValue;
		setRotation(newRotation * -1);
	}


	useEffect(() => {
		setRy(gsap.utils.random(-0.5, 0.5));
		setRz(gsap.utils.random(-0.5, 0.5));
		setRotVal(gsap.utils.random(-90,-60));
	}, []);
	useEffect(() => {
		getSize();
	}, [ready, winsize]);
	useEffect(() => {
		update();
	}, [progress, winsize, pos]);

	const scaledNorm = Math.max(1 - Math.abs(normVal * 1.125), 0.1);
	const opacityNorm = (0.8 - Math.abs(normVal)) * 1.5;

	return (
		<div className={
			cx(styles.effectWrapper, {[styles.debug]: debug, [styles.dupe]: dupe})
		} data-prog={normVal.toFixed(2)} style={{zIndex}}>
			<div className={styles.imageFrame} ref={wrap}>
				<div className={styles.image} style={{
					transform: `rotate3d(1,${ry},${rz},${rotation}deg) scale(${scaledNorm})`,
					opacity: opacityNorm
				}}>
					{children}
				</div>
			</div>
		</div>
	);
}